import type { AiAppCenterModule } from '../types'

export const finModule: AiAppCenterModule = {
  key: 'fin',
  label: '投融资',
  desc: '融资管理 / 投资分析 / 资金管理',
  path: '/fin',
  homePath: '/fin/overview',
  icon: 'ep:trend-charts',
  color: '#0891b2'
}
